module.exports = __webpack_public_path__ + "img/GDC-alt.72ca8670.svg";